module.exports = __webpack_public_path__ + "img/otcIconNew.920be0bb.png";